import React from 'react';
import { QueryStatsRounded } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { theme } from '../../../theme';
import { formatCurrency } from '../../../utils/formatNumbers';

function ItemReplacementItemSummary({ item, label, color, inContract, stats = {} }) {
    const cost = Number(item.cost);
    const usageValueColor = inContract === true
        ? theme.palette.green.taskText
        : inContract === false
            ? theme.palette.red.main
            : theme.palette.subtext.main;
    const formattedSpend = formatCurrency(Number.isFinite(Number(stats.annualSpend)) ? Number(stats.annualSpend) : 0, 0);

    return (
        <Stack spacing={1} sx={{ backgroundColor: theme.palette.background.white, borderRadius: 1, boxShadow: 1, p: 1.75 }}>
            <Typography variant='heavy' sx={{ color, fontSize: '13px' }}>{label}</Typography>
            <Typography variant='heavy' sx={{ fontSize: '14px', lineHeight: 1.2 }}>{item.name}</Typography>
            <Stack direction='row' alignItems='center' flexWrap='wrap' columnGap={1} rowGap={0.5}>
                <Typography variant='normal' sx={{ color: theme.palette.subtext.main, fontSize: '12px' }}>{item.vendor?.name} | {item.part_number}</Typography>
                <Typography variant='heavy' sx={{ fontSize: '12px' }}>{formatCurrency(Number.isFinite(cost) ? cost : 0)}</Typography>
                {inContract === true && (
                    <Typography variant='heavy' sx={{ ml: 'auto', px: 1, py: 0.5, borderRadius: 1, backgroundColor: theme.palette.itemSwapChip.background.positive, color: theme.palette.itemSwapChip.text.positive, fontSize: '12px', whiteSpace: 'nowrap' }}>In Contract</Typography>
                )}
                {inContract === false && (
                    <Typography variant='heavy' sx={{ ml: 'auto', px: 1, py: 0.5, borderRadius: 1, backgroundColor: theme.palette.itemSwapChip.background.negative, color: theme.palette.itemSwapChip.text.negative, fontSize: '12px', whiteSpace: 'nowrap' }}>Off-Contract</Typography>
                )}
            </Stack>
            <Stack direction='row' alignItems='flex-start' spacing={0.75}>
                <QueryStatsRounded aria-hidden='true' sx={{ mt: '1px', color: theme.palette.subtext.secondary, fontSize: '18px', flexShrink: 0 }} />
                <Typography variant='normal' sx={{ color: theme.palette.subtext.main, fontSize: '13px', lineHeight: 1.4 }}>
                    Used in <Typography component='span' variant='normal' sx={{ color: usageValueColor, fontSize: 'inherit' }}>{stats.caseCount ?? 0}</Typography> cases in last year
                    {Number(stats.caseCount) > 0 && <>, <Typography component='span' variant='normal' sx={{ color: usageValueColor, fontSize: 'inherit' }}>{formattedSpend}</Typography> spent</>}
                </Typography>
            </Stack>
        </Stack>
    );
}

export default ItemReplacementItemSummary;
